let inName = document.querySelector("#inName");
let errorName = document.querySelector("#emName");
let inEmail = document.querySelector("#inEmail");
let errorEmail = document.querySelector("#emEmail");
let inEmailConfirm = document.querySelector("#inEmail-confirm"); // 確認用メールアドレスの要素を取得
let errorEmailConfirm = document.querySelector("#emEmail-confirm"); // 確認用メールアドレスのエラー要素を取得
let inSelect = document.querySelector("#inSelect");
let errorSelect = document.querySelector("#emSelect");
let inTextarea = document.querySelector("#inTextarea");
let errorTextarea = document.querySelector("#emTextarea");
let inPrivacy = document.querySelector("#inPrivacy");
let errorPrivacy = document.querySelector("#emPrivacy");
const form = document.querySelector("#contact-form");
const submitButton = form.querySelector("#button");

// 初期状態で送信ボタンを無効化
submitButton.disabled = true;
submitButton.classList.add("disabled");

// フォームの入力チェック関数
function validateForm() {
  const isNameValid = inName.value.trim() !== "";
  const isEmailValid = inEmail.value.includes("@");
  const isEmailConfirmValid = inEmail.value === inEmailConfirm.value; // 確認用メールアドレスの一致を確認
  const isSelectValid =
    inSelect.value !== "選択してください" && inSelect.value.trim() !== "";
  const isTextareaValid = inTextarea.value.trim() !== "";
  const isPrivacyChecked = inPrivacy.checked;

  // すべての必須項目が入力されているか判定
  const isFormValid =
    isNameValid &&
    isEmailValid &&
    isEmailConfirmValid && // 確認用メールアドレスのチェックを追加
    isSelectValid &&
    isTextareaValid &&
    isPrivacyChecked;

  // ボタンの有効・無効の切り替え
  submitButton.disabled = !isFormValid;
  submitButton.classList.toggle("disabled", !isFormValid);
}

// 各入力フィールドにイベントリスナーを追加（リアルタイムチェック）
[inName, inEmail, inEmailConfirm, inSelect, inTextarea, inPrivacy].forEach(
  // inEmailConfirm を追加
  (input) => {
    input.addEventListener("input", validateForm);
  }
);

// 初回チェック（ページロード時）
validateForm();

submitButton.addEventListener("click", function (event) {
  if (inName.value.trim() === "") {
    inName.classList.add("invalid");
    errorName.textContent = "必須項目です。";
    scrollToElement(inName);
    event.preventDefault();
  } else {
    errorName.textContent = "";
    inName.classList.remove("invalid"); // エラー表示をクリア
  }

  if (!inEmail.value.includes("@")) {
    inEmail.classList.add("invalid");
    errorEmail.textContent = "メールアドレスの形式でご入力ください。";
    scrollToElement(inEmail);
    event.preventDefault();
  } else {
    errorEmail.textContent = "";
    inEmail.classList.remove("invalid"); // エラー表示をクリア
  }

  // 確認用メールアドレスのチェック
  if (inEmail.value !== inEmailConfirm.value) {
    inEmailConfirm.classList.add("invalid");
    errorEmailConfirm.textContent = "メールアドレスが一致しません。";
    scrollToElement(inEmailConfirm);
    event.preventDefault();
  } else {
    errorEmailConfirm.textContent = "";
    inEmailConfirm.classList.remove("invalid"); // エラー表示クリア
  }

  if (inSelect.value === "選択してください" || inSelect.value.trim() === "") {
    inSelect.classList.add("invalid");
    errorSelect.textContent = "選択してください。";
    scrollToElement(inSelect);
    event.preventDefault();
  } else {
    errorSelect.textContent = "";
    inSelect.classList.remove("invalid");
  }

  if (inTextarea.value.trim() === "") {
    inTextarea.classList.add("invalid");
    errorTextarea.textContent = "必須項目です。";
    scrollToElement(inTextarea);
    event.preventDefault();
  } else {
    errorTextarea.textContent = "";
    inTextarea.classList.remove("invalid");
  }

  if (!inPrivacy.checked) {
    inPrivacy.classList.add("invalid");
    errorPrivacy.textContent = "必須項目です。";
    scrollToElement(inPrivacy);
    event.preventDefault();
  } else {
    errorPrivacy.textContent = "";
    inPrivacy.classList.remove("invalid");
  }

  function scrollToElement(element) {
    element.scrollIntoView({ behavior: "smooth", block: "center" });
  }
});

inName.onblur = function () {
  if (!inName.value) {
    inName.classList.add("invalid");
    errorName.innerHTML = "必須項目です。";
  }
};
inName.onfocus = function () {
  if (this.classList.contains("invalid")) {
    inName.classList.remove("invalid");
    errorName.innerHTML = "";
  }
};
inEmail.onblur = function () {
  if (!inEmail.value.includes("@")) {
    inEmail.classList.add("invalid");
    errorEmail.innerHTML = "メールアドレスの形式でご入力ください。";
  }
};
inEmail.onfocus = function () {
  if (this.classList.contains("invalid")) {
    inEmail.classList.remove("invalid");
    errorEmail.innerHTML = "";
  }
};

// 確認用メールアドレスの onblur, onfocus イベント
inEmailConfirm.onblur = function () {
  if (inEmail.value !== inEmailConfirm.value) {
    inEmailConfirm.classList.add("invalid");
    errorEmailConfirm.textContent = "メールアドレスが一致しません。";
  }
};
inEmailConfirm.onfocus = function () {
  if (this.classList.contains("invalid")) {
    inEmailConfirm.classList.remove("invalid");
    errorEmailConfirm.textContent = "";
  }
};

inSelect.onblur = function () {
  if (inSelect.value === "選択してください" || inSelect.value.trim() === "") {
    inSelect.classList.add("invalid");
    errorSelect.innerHTML = "選択してください。";
  }
};
inSelect.onfocus = function () {
  if (this.classList.contains("invalid")) {
    inSelect.classList.remove("invalid");
    errorSelect.innerHTML = "";
  }
};
inTextarea.onblur = function () {
  if (!inTextarea.value) {
    inTextarea.classList.add("invalid");
    errorTextarea.innerHTML = "必須項目です。";
  }
};
inTextarea.onfocus = function () {
  if (this.classList.contains("invalid")) {
    inTextarea.classList.remove("invalid");
    errorTextarea.innerHTML = "";
  }
};
inPrivacy.onchange = function () {
  if (!inPrivacy.checked) {
    inPrivacy.classList.add("invalid");
    errorPrivacy.innerHTML = "必須項目です。";
  } else {
    inPrivacy.classList.remove("invalid");
    errorPrivacy.innerHTML = "";
  }
};

// 送信処理（Google reCAPTCHA 対応？）
function onSubmit(token) {
  // バリデーションが全て通った場合のみ送信 (条件を反転)
  if (
    inPrivacy.checked &&
    inTextarea.value.trim() !== "" &&
    inSelect.value !== "選択してください" &&
    inSelect.value.trim() !== "" &&
    inEmail.value.includes("@") &&
    inName.value.trim() !== "" &&
    inEmail.value === inEmailConfirm.value //ここに追加
  ) {
    document.getElementById("contact-form").submit();
  }
}
